import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Home, Compass, BookMarked, History, Menu } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useAuth } from "@/context/AuthContext";
import { useCatalogue } from "@/context/CatalogueContext";
import { teamColour } from "@/lib/constants";
import { cn } from "@/lib/utils";

const ITEMS = [
  { to: "/", label: "Home", icon: Home, end: true, id: "home" },
  { to: "/agents", label: "Find", icon: Compass, id: "find" },
  { to: "/prompts", label: "Prompts", icon: BookMarked, id: "prompts" },
  { to: "/runs", label: "My runs", icon: History, id: "runs" },
];

export const BottomNav = () => {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const { teams } = useCatalogue();
  const navigate = useNavigate();
  const go = (to) => { setOpen(false); navigate(to); };
  const linkClass = ({ isActive }) =>
    cn("flex flex-1 flex-col items-center gap-0.5 py-2 text-xs transition-quick", isActive ? "text-foreground font-medium" : "text-muted-foreground");
  return (
    <>
      <nav className="fixed inset-x-0 bottom-0 z-40 flex border-t bg-card/95 backdrop-blur-md md:hidden" aria-label="Main navigation" data-testid="bottom-nav">
        {ITEMS.map(({ to, label, icon: Icon, end, id }) => (
          <NavLink key={id} to={to} end={end} className={linkClass} data-testid={`bottom-nav-${id}`}>
            <Icon aria-hidden="true" />
            {label}
          </NavLink>
        ))}
        <button type="button" onClick={() => setOpen(true)} className="flex flex-1 flex-col items-center gap-0.5 py-2 text-xs text-muted-foreground" data-testid="bottom-nav-more">
          <Menu aria-hidden="true" />
          More
        </button>
      </nav>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" className="rounded-t-xl" data-testid="bottom-nav-sheet">
          <SheetHeader><SheetTitle>More</SheetTitle></SheetHeader>
          <div className="mt-4 grid gap-1">
            <p className="px-2 text-xs font-medium text-muted-foreground">Teams</p>
            {teams.map((t, i) => (
              <button key={t.id} type="button" onClick={() => go(`/teams/${t.id}`)} className="flex items-center gap-3 rounded-xl px-2 py-2 text-left text-sm hover:bg-muted" data-testid={`sheet-team-${t.id}`}>
                <span className="h-2 w-2 rounded-full" style={{ background: teamColour(t, i) }} aria-hidden="true" />
                {t.section || t.name}
              </button>
            ))}
            <div className="my-2 border-t" />
            {[["/feedback", "Feedback"], ["/whats-new", "What's new"], ["/profile", "Profile"], ...(user?.role === "owner" ? [["/admin", "Admin"]] : [])].map(([to, label]) => (
              <button key={to} type="button" onClick={() => go(to)} className="rounded-xl px-2 py-2 text-left text-sm hover:bg-muted" data-testid={`sheet-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                {label}
              </button>
            ))}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};
